import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { Box, Typography } from '@mui/material';
import { GridCellParams, GridFilterModel } from '@mui/x-data-grid-premium';
import React, { Dispatch, SetStateAction, useState } from 'react';

import { TrackedIconButton as IconButton } from '../../../components/TrackedComponents';
import { formatLicensePlateWithInternalId } from '../../../utils/Str';

export interface EventLicensePlateCellProps {
    params: GridCellParams;
    showVehicleInternalId: boolean;
    setFilterModel: Dispatch<SetStateAction<GridFilterModel>>;
}

export const EventLicensePlateCell: React.FC<EventLicensePlateCellProps> = ({
    params,
    showVehicleInternalId,
    setFilterModel,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const display = formatLicensePlateWithInternalId(
        params.value as string,
        params.row.device_internal_id as string | number | null | undefined,
        showVehicleInternalId,
    );
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Typography>{display}</Typography>
            <Box sx={{ display: isHovered ? 'flex' : 'none', alignItems: 'center', ml: 0.5 }}>
                <IconButton
                    id={`add-filter-${params.row.id}`}
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        setFilterModel((prev: GridFilterModel) => ({
                            ...prev,
                            items: [
                                ...prev.items.filter((item) => item.field !== params.field),
                                {
                                    field: params.field,
                                    operator: 'equals',
                                    value: params.value,
                                },
                            ],
                        }));
                    }}
                >
                    <ZoomInIcon />
                </IconButton>
            </Box>
        </Box>
    );
};
